import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

(function (Drupal) {
  function ensureTrackHasList(trackEl) {
    const ul = trackEl.querySelector('ul');
    if (!ul) return null;

    if (ul.parentElement !== trackEl) {
      trackEl.appendChild(ul);
    }

    ul.classList.add('splide__list');
    ul.querySelectorAll('li').forEach((li) => li.classList.add('splide__slide'));

    return ul;
  }

  Drupal.behaviors.membersLogosCarousel = {
    attach(context) {
      const roots = context.querySelectorAll('[data-members-logos]');

      roots.forEach((root) => {
        if (root.dataset.membersLogosProcessed === 'true') return;
        root.dataset.membersLogosProcessed = 'true';

        const topTrack = root.querySelector('[data-track="top"]');
        const bottomTrack = root.querySelector('[data-track="bottom"]');
        if (!topTrack || !bottomTrack) return;

        const topUl = ensureTrackHasList(topTrack);
        const bottomUl = ensureTrackHasList(bottomTrack);
        if (!topUl || !bottomUl) return;

        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (!isMobile) {
          const topLis = Array.from(topUl.querySelectorAll('li'));

          topLis.forEach((li, i) => {
            if (i % 2 === 1) {
              bottomUl.appendChild(li);
            }
          });
        }

        bottomUl.querySelectorAll('li').forEach((li) => {
          li.classList.add('splide__slide');
        });

        const topSplideEl = root.querySelector('[data-splide-row="top"]');
        const bottomSplideEl = root.querySelector('[data-splide-row="bottom"]');
        if (!topSplideEl || !bottomSplideEl) return;

        const common = {
          type: 'loop',
          arrows: false,
          pagination: false,
          drag: false,
          autoplay: false,
          speed: 600,
          gap: 24,
          perPage: 6,
          autoWidth: false,
          autoScroll: {
            speed: 1.2,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
          breakpoints: {
            1024: {
              perPage: 4,
              gap: 24,
            },
            767: {
              perPage: 2,
              gap: 16,
            },
          },
        };

        new Splide(topSplideEl, common).mount({ AutoScroll });

        if (!isMobile) {
          new Splide(bottomSplideEl, { ...common, direction: 'rtl' }).mount({
            AutoScroll,
          });
        }
      });
    },
  };
})(Drupal);
